import * as React from 'react';
import { ArrowRight } from 'lucide-react';

interface WorkshopCardProps {
	day: string;
	month: string;
	year: string;
	title: string;
	time: string;
	location: string;
	variant?: 'dark' | 'light';
	price?: string;
	limit?: number;
	onClick?: () => void;
}

export const WorkshopCard: React.FC<WorkshopCardProps> = ({
	day,
	month,
	year,
	title,
	time,
	location,
	variant = 'light',
	price = 'Free',
	limit,
	onClick,
}) => {
	const isDark = variant === 'dark';
	const isSoldOut = limit === 0;

	return (
		<article
			onClick={onClick}
			className={`p-8 w-full rounded-3xl ${
				isDark ? 'bg-neutral-800' : 'bg-zinc-300'
			} max-md:px-5 ${onClick ? 'cursor-pointer hover:opacity-90 transition-opacity' : ''}`}
		>
			<div className='w-full'>
				<header className='flex gap-10 justify-between items-start w-full'>
					<time
						className={`w-24 min-h-[52px] ${
							isDark ? 'text-white' : 'text-neutral-800'
						}`}
						dateTime={`${year}-${month}-${day}`}
					>
						<span className='text-4xl leading-none font-[250]'>{day}</span>
						<span className='block mt-2 text-xs leading-none uppercase'>
							{month} {year}
						</span>
					</time>
					<div className='flex gap-2 items-center p-2 w-8 min-h-8'>
						<ArrowRight
							className='w-4 h-4 transform -rotate-45'
							color={isDark ? 'white' : 'black'}
						/>
					</div>
				</header>
				<h3
					className={`mt-10 text-base leading-6 ${
						isDark ? 'text-white' : 'text-neutral-800'
					}`}
				>
					{title}
				</h3>
				{isSoldOut && (
					<div
						className={`mt-2 inline-block px-2 py-1 rounded text-xs font-medium ${isDark ? 'bg-red-500 text-white' : 'bg-red-100 text-red-800'}`}
					>
						Sold Out
					</div>
				)}
				{!isSoldOut && limit !== undefined && (
					<div
						className={`mt-2 text-xs ${isDark ? 'text-white opacity-80' : 'text-neutral-800 opacity-70'}`}
					>
						{limit} seats available
					</div>
				)}
				<div
					className={`mt-3 font-medium ${isDark ? 'text-white' : 'text-neutral-800'}`}
				>
					R{price}
				</div>
			</div>
			<footer
				className={`flex-1 shrink self-stretch pt-4 mt-6 w-full text-xs leading-4
          border-t basis-0 ${
						isDark
							? 'border-white border-opacity-20 text-white'
							: 'border-neutral-800 border-opacity-20 text-neutral-800'
					}`}
			>
				<p>{time}</p>
				<p>{location}</p>
			</footer>
		</article>
	);
};
